export default __webpack_public_path__ + "static/media/circle-2.8aa93b1b.svg";